<script setup lang="ts">
import { ref } from 'vue';
import './index.scss';


// Define isOpen with boolean type
const isOpen = ref<boolean>(false)

// Function to toggle the menu
function toggleMenu(): void {
    isOpen.value = !isOpen.value
}
</script>

<template>
    <div>
        <!-- Burger Icon -->
        <button class="burger-button" @click="toggleMenu" aria-label="Toggle Menu">
            <span :class="{ open: isOpen }" class="burger-icon"></span>
        </button>

        <!-- Menu Overlay -->
        <transition name="fade">
            <div v-if="isOpen" class="menu-overlay" @click="toggleMenu">
                <nav class="menu-nav" @click.stop>
                    <slot />
                </nav>
            </div>
        </transition>
    </div>
</template>
